import { render } from "./BibliographyView.vue?vue&type=template&id=720e17b0&lang=pug"
import script from "./BibliographyView.vue?vue&type=script&lang=js"
export * from "./BibliographyView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__